import { useDeleteDiscount } from "http-hooks/discount/useDiscount";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteDiscount({ id, onClose }) {
  const { mutateAsync, isPending } = useDeleteDiscount();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      // Error toast already shown by service
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Discount"
      description="Are you sure you want to delete this discount? This discount will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
} 